// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__tUpAT","logout-button":"LogoutButton_logout-button__IZJiu","text":"LogoutButton_text__VWn7j"};